import { cn } from '../../../lib/utils'
import type { AlertPhase } from '../../../lib/alert-phase'

interface AlertVignetteProps {
  phase: AlertPhase
  /** S 波倒计时 <10s：最强紧迫态（红缘呼吸 + 抖动由根节点 shake 类承担） */
  urgent: boolean
}

/**
 * 紧迫感全屏叠层：
 * - urgent：红色内缘呼吸（S 波临近，最强）
 * - CRITICAL 相位但未 urgent：静态红缘（事件进行中）
 * 纯 pointer-events-none 装饰层，不拦截任何交互。
 */
export function AlertVignette({ phase, urgent }: AlertVignetteProps) {
  if (!urgent && phase !== 'CRITICAL') return null
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none fixed inset-0 z-40',
        urgent ? 'alert-vignette' : 'alert-vignette-mild',
      )}
    />
  )
}
